import { useState, useContext } from 'react';
import './index.css';
import ButtonGroup from '../../molecules/buttonGroup/view';
import { roleContext } from '../../../context/role/context';
import PlanCuentas from '../../organisms/planCuentas/view';
import Parameterization from '../../organisms/parameterization/view';
import CreateComprobante from '../../organisms/create-comprobante/view';
import CloneComprobanteModal from '../../organisms/CloneComprobanteModal/view.jsx';
import AnularComprobanteModal from '../../organisms/AnularComprobanteModal/view.jsx';
import EditComprobanteModal from '../../organisms/EditComprobanteModal/view.jsx';
import Taxes from '../../organisms/taxes/view.js';
import AccountingReportsModalButton from '../../organisms/AccountingReportsModalButton/view.js';
import ReceiptTypeTable from '../../organisms/ReceiptTypeTable/view.js';
import Spends from '../../organisms/Spends/view.js';
import TabSwitcher from '../../molecules/TabSwitcher/view';
import AccountingComprobantesTable from '../../organisms/AccountingComprobantesTable/view';

import AccountingClosureModal from '../../organisms/AccountingClosureModal/view'; // Asegurar ruta
import CargaMasivaModal from '../../organisms/cargaMasivaModal/view';
import NewThird from '../../organisms/newThird/view';
import CostingModal from '../../organisms/CostingModal/view'; // Nuevo componente
import TaxClosureModal from '../../organisms/TaxClosureModal/view'; // Feature Cierre de Impuestos
import Cuentas from '../../organisms/cuentas/view'

const Accounting = () => {
  const { profile } = useContext(roleContext);
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      name: "Comprobantes",
      component: () => (
        <AccountingComprobantesTable profile={profile} />
      ),
    },
    {
      name: "Configuración",
      component: () => (
        <PlanCuentas profile={profile} />
      ),
    }
  ];

  return (
    <>
      {
        activeTab === 0 && (
          <ButtonGroup
            title="Contabilidad y Libros"
            description="Gestiona tus estados financieros, impuestos y cierres contables."
          >
            <AccountingReportsModalButton profile={profile} />
            <CreateComprobante />
            <CargaMasivaModal />
            <NewThird />
            <AccountingClosureModal id="accounting-closure-modal" year={new Date().getFullYear()} />
            <CostingModal id="costing-modal" year={new Date().getFullYear()} />
            <TaxClosureModal id="tax-closure-modal" year={new Date().getFullYear()} />
          </ButtonGroup>
        )
      }
      {
        activeTab === 1 && (
          <ButtonGroup
            title="Contabilidad y Libros"
            description="Gestiona tus estados financieros, impuestos y cierres contables."
          >
            <Taxes profile={profile} />
            <Spends />
            <ReceiptTypeTable profile={profile} />
            <Parameterization profile={profile} />
            <Cuentas profile={profile} id="accounting" />
          </ButtonGroup>
        )
      }
      <CloneComprobanteModal />
      <AnularComprobanteModal />
      <EditComprobanteModal />
      <TabSwitcher tabs={tabs} onTabChange={setActiveTab} hashKey="tab" />
    </>
  );
};

export default Accounting;
